import { TweenMax, TimelineMax } from 'gsap';
import css from './index.module.scss';
import GsapD1 from './gsapD1/gsapD1';
import GsapD2 from './gsapD1/gsapD2';
import GsapDText1 from './gsapDText1';
import { useGlobal } from '@/utils/useGlobal';

export default function AnimationD({}: any) {
    const { useEffect } = useGlobal();

    useEffect(() => {
        const controller = new ScrollMagic.Controller();
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationD',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.animationD .gsapD1 .box-l-inter', 0.3, {
            opacity: 0,
            y: -40,
        });
        const tweenA2 = TweenMax.to('.animationD .gsapD1 .box-r', 0.3, {
            opacity: 0,
        });
        const tweenA3 = TweenMax.to('.animationD .gsapD2 .box-l-inter', 0.5, {
            opacity: 1,
            y: -40,
        });
        const tweenA4 = TweenMax.to('.animationD .gsapD2 .box-r', 0.5, {
            opacity: 1,
            zIndex: 10,
        });
        const tweenA5 = TweenMax.to('.animationD .ef-scroll-ani-a2', 0.01, {
            zIndex: 10,
        });
        const tweenA6 = TweenMax.to('.animationD .gsapD2 .box-l-inter', 0.1, {
            opacity: 0,
        });
        const tweenA7 = TweenMax.to('.animationD .gsapD2 .box-r', 0.1, {
            opacity: 0,
        });
        const tweenA8 = TweenMax.to('.animationD .ef-scroll-ani-a3', 0.3, {
            opacity: 1,
        });

        const timelineA1 = new TimelineMax();
        timelineA1.add(tweenA1).add(tweenA2, 0).add(tweenA3, 0.2).add(tweenA4, 0.2).add(tweenA5, 0.2).add(tweenA6, 0.7).add(tweenA7, 0.7).add(tweenA8, 0.7);

        sceneA1.setTween(timelineA1);
        controller.addScene(sceneA1);
    }, []);

    return (
        <>
            <div id="animationD-trigger-1"></div>
            <div className={`${css.animationD} animationD`}>
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani ef-scroll-ani-a1">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapD1 />
                            </div>
                        </div>
                    </div>

                    <div className="ef-scroll-ani ef-scroll-ani-a2">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapD2 />
                            </div>
                        </div>
                    </div>

                    <div className="ef-scroll-ani ef-scroll-ani-a3">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapDText1 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
